package com.milta.core.localization.translations.fr

import com.milta.core.localization.TeamStrings

internal val Team = TeamStrings(
    screenTitle = "Équipe",
    sectionLabel = "Organisations connectées",
    connectedSince = "Rattaché depuis le",
    statusActive = "Actif",
    statusBroken = "Connexion rompue",
    brokenMessage = "Cette organisation n'est plus disponible. Vous ne recevrez plus de tournées de sa part. Votre compte Livreur reste actif.",
    dismissBroken = "Masquer cette organisation",
    emptyHint = "Vous n'êtes rattaché à aucune organisation. Un Patron peut vous ajouter via votre code de liaison (voir Profil).",
    errorGeneric = "Une erreur s'est produite. Veuillez réessayer.",
    monthNames = listOf("janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"),
    enterpriseSectionLabel = "Chauffeurs de l'équipe",
    enterpriseEmptyHint = "Aucun chauffeur dans votre équipe pour l'instant.",
    noEnterpriseFound = "Aucune entreprise associée à votre compte.",
    columnHeaderDriver = "Chauffeur",
    columnHeaderStatus = "Statut",
    columnHeaderActions = "Actions",
    addDriverSectionTitle = "Ajouter un chauffeur",
    addDriverCodePlaceholder = "Code Milta — ex : MTA-28371",
    addDriverButton = "Ajouter ce chauffeur",
    addDriverErrorInvalidCode = "Veuillez entrer un code valide.",
    addDriverErrorNotFound = "Code invalide ou déjà utilisé.",
    addDriverErrorAlreadyMember = "Ce chauffeur fait déjà partie de votre équipe.",
    addDriverErrorLinkedAccountIsEnterprise = "Ce compte est une entreprise et ne peut pas être ajouté comme chauffeur.",
    driverDetailTitle = "Détail du chauffeur",
    driverDetailPhoneLabel = "Téléphone",
    removeDriverButton = "Retirer",
    removeDriverDialogTitle = "Retirer ce chauffeur ?",
    removeDriverDialogMessagePrefix = "Vous êtes sur le point de retirer",
    removeDriverDialogMessageSuffix = "de votre équipe. Son compte Milta restera actif.",
    removeDriverErrorNotFound = "Chauffeur introuvable.",
    removeDriverErrorOnActiveDelivery = "Ce chauffeur est actuellement en cours de livraison et ne peut pas être retiré.",
    removeDriverErrorLastOwner = "Vous êtes le seul gestionnaire de cette entreprise. Ajoutez un autre compte Entreprise avant de vous retirer de l'équipe.",
)
